import store from 'source/store';

function canAccessHRPages(to, from, next) {
    const { is_hr, employment_policies } = store.state.auth.user.user_profile;
    const hasAccessToEP = employment_policies.includes(parseInt(to.params.employment_policy_id));

    if (!is_hr || !hasAccessToEP) {
        next({ name: 'access-denied', replace: true });
    } else {
        next();
    }
}

function hasListAccess(to, from, next) {
    const { is_hr, permissions } = store.state.auth.user.user_profile;
    const hasHrSectionAcccess = permissions.includes('can_access_hr_section');

    if (!is_hr && !hasHrSectionAcccess) {
        next({ name: 'access-denied', replace: true });
    } else {
        next();
    }
}

function canViewPayrolls(to, from, next) {
    const { is_hr, can_view_payroll } = store.state.auth.user.user_profile;

    if (!is_hr || !can_view_payroll) {
        next({ name: 'access-denied', replace: true });
    } else {
        next();
    }
}

const hrPortalChildren = [
    {
        path: 'career-policy-list',
        name: 'career-policy-list',
        beforeEnter: hasListAccess,
        component: () =>
            import('source/pages/hr-portal/CareerPolicyListPage.vue'),
        meta: {
            title: 'Career Policy - HQZen',
        },
    },
    {
        path: ':employment_policy_id/overview',
        name: 'hr-overview',
        component: () =>
            import('source/pages/hr-portal/HRPortalOverviewPage.vue'),
        meta: {
            title: 'HR Portal - HQZen',
        },
    },
    {
        path: ':employment_policy_id/leaves',
        name: 'hr-leaves',
        component: () =>
            import('source/pages/hr-portal/leaves/HRLeavesPage.vue'),
        meta: {
            title: 'HR Portal - HQZen',
        },
    },
    {
        path: ':employment_policy_id/leaves/details/:leave_id/',
        name: 'hr-leaves-details',
        component: () =>
            import('source/pages/supervisor-manager/leaves/LeaveRequestDetailsPage.vue'),
        meta: {
            title: 'Details - HQZen',
            canDisplayGlobalModals: true
        },
    },
    {
        path: ':employment_policy_id/incident-reports',
        name: 'hr-incident-reports',
        component: () =>
            import('source/pages/hr-portal/incident-reports/HRIncidentReportsPage.vue'),
        meta: {
            title: 'HR Portal - HQZen',
        },
    },
    {
        path: ':employment_policy_id/incident-reports/:ir_id/details',
        name: 'hr-incident-reports-details',
        props: true,
        component: () => import('source/pages/supervisor-manager/ir/IncidentReportDetailsPage.vue'),
        meta: {
            title: 'Details - HQZen',
        },
    },
    {
        path: ':employment_policy_id/separations',
        name: 'hr-separations',
        component: () =>
            import('source/pages/supervisor-manager/SeparationsPage.vue'),
        meta: {
            title: 'HR Portal - HQZen'
        },
    },
    {
        path: ':employment_policy_id/pcn',
        name: 'hr-pcn',
        component: () =>
            import('source/pages/hr-portal/pcn/HRPCNPage.vue'),
        meta: {
            title: 'HR Portal - HQZen'
        },
    },
    {
        path: ':employment_policy_id/pcn/:pcn_id/request',
        name: 'hr-pcn-request',
        component: () =>
            import ('source/pages/hr-portal/pcn/PCNFormPage.vue'),
        meta: {
            title: 'View PCN Request - HQZen'
        },
    },
    {
        path: ':employment_policy_id/partners/details/:employment_id/hr-file-pcn-form/:partner_workforce_id',
        name: 'hr-file-pcn-form',
        component: () =>
            import ('source/pages/hr-portal/pcn/PCNFormPage.vue'),
        props: true,
        meta: {
            title: 'File a Personnel Change Notice - HQZen'
        }
    },
    {
        path: ':employment_policy_id/payrolls',
        name: 'hr-payrolls',
        beforeEnter: canViewPayrolls,
        component: () =>
            import('source/pages/employers/administrator/sub-sections/Payrolls.vue'),
        meta: {
            title: 'HR Portal - HQZen',
        },
    },
    {
        path: ':employment_policy_id/payrolls/employee-payrolls/:payroll_period_id',
        name: 'hr-payroll-table',
        component: () =>
            import (
                'source/pages/employers/payrolls/PayrollPeriodDetailsPage.vue'
            ),
        props: true,
        meta: {
            title: 'Payroll Period - HQZen',
            canDisplayGlobalModals: true,
            isAdministratorRoute: true,
        },
    },
    {
        path: ':employment_policy_id/partners/create-schedule',
        name: 'hr-create-schedule',
        props: true,
        component: () => import('source/pages/schedules/CreateSchedulePage.vue'),
        meta: {
            title: 'Partners - HQZen',
            canDisplayGlobalModals: true
        },
    },
    {
        path: ':employment_policy_id/partners',
        name: 'hr-employees',
        props: true,
        component: () => import('source/pages/supervisor-manager/SMEmployeesPage.vue'),
        meta: {
            title: 'Partners - HQZen',
            canDisplayGlobalModals: true
        },
    },
    {
        path: ':employment_policy_id/disciplinary-action-forms',
        name: 'hr-disciplinary-action-forms',
        component: () =>
            import('source/pages/hr-portal/disciplinary-action-forms/HRDisciplinaryActionFormsPage.vue'),
        meta: {
            title: 'HR Portal - HQZen',
        },
    },
    {
        path: ':employment_policy_id/disciplinary-action-forms/:daf_id/details',
        name: 'hr-daf-details',
        props: true,
        component: () => import('source/pages/supervisor-manager/daf/DisciplinaryActionFormDetailsPage.vue'),
        meta: {
            title: 'Details - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/partners/details/:employment_id',
        name: 'hr-employee-details',
        props: true,
        component: () => import('source/pages/supervisor-manager/employees/EmployeesPage.vue'),
        meta: {
            title: 'Partner Details - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/partners/details/:employment_id/:pcn_id',
        name: 'hr-partner-pcn-details',
        component: () => import ('source/pages/supervisor-manager/employees/PCNPartnerDetailsPage.vue'),
        props: true,
        meta: {
            title: 'View Partner PCN Details - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/requirements',
        name: 'hr-requirements',
        component: () =>
            import('source/pages/hr-portal/HRRequirementsPage.vue'),
        meta: {
            title: 'HR Portal - HQZen',
        },
    },
    {
        path: ':employment_policy_id/accountabilities',
        name: 'hr-accountabilities',
        props: true,
        component: () =>
            import('source/pages/supervisor-manager/SMAccountabilitiesPage.vue'),
        meta: {
            title: 'HR Portal - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/accountabilities/details/:accountability_id',
        name: 'hr-accountabilities-details',
        props: true,
        component: () =>
            import('source/pages/supervisor-manager/accountabilities/AccountabilityDetailsPage.vue'),
        meta: {
            title: 'Details - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/separations/details/:resignation_pk',
        name: 'hr-resignation-details',
        props: true,
        component: () => import('source/pages/supervisor-manager/separations/ResignationDetailsPage.vue'),
        meta: {
            title: 'Resignation Details - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/separations/clearance-details/:clearance_pk',
        name: 'hr-clearance-details',
        props: true,
        component: () =>
            import('source/components/supervisor-manager/separation/clearance/ClearanceDetailsPage.vue'),
        meta: {
            title: 'Clearance Details - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/separations/forced-termination/:separation_pk',
        name: 'hr-forced-termination-details',
        props: true,
        component: () =>
            import(
                'source/components/supervisor-manager/separation/forced-termination/ForcedTerminationDetailsPage.vue'),
        meta: {
            title: 'Forced Termmination Details - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/partners/details/:employment_id/contract',
        name: 'hr-staff-contract-workflow',
        component: () =>
            import ('source/pages/employers/contracts/ContractWorkflowPage.vue'),
        props: true,
        meta: {
            title: 'Contract - HQZen',
            canDisplayGlobalModals: true
        }
    },
    {
        path: ':employment_policy_id/partners/details/:employment_id/contracts',
        name: 'hr-staff-contracts',
        props: true,
        component: () => import('source/pages/supervisor-manager/employees/EmployeeContractsPage.vue'),
        meta: {
            title: 'Partner Contract - HQZen',
            canDisplayGlobalModals: true
        },
        children: [
            {
                path: 'details/:contract_id',
                name: 'hr-staff-contract-details',
                component: () => import('source/pages/supervisor-manager/employees/ContractDetailsPage.vue'),
                props: true,
                meta: {
                    title: 'Contract Details - HQZen',
                    canDisplayGlobalModals: true
                }
            }
        ]
    },
];

// Adding guard to routes with `employment_policy_id`
const guardedChildren = hrPortalChildren.map(child => {
    // disregard if child has own beforeEnter function or does not have selected career policy
    const isIncluded = child.path.includes(':employment_policy_id') && !child.beforeEnter;
    return isIncluded ? { ...child, beforeEnter: canAccessHRPages } : child;
});


export default [{
    path: '/company/:company_id/hr-portal',
    name: 'hr-portal',
    component: () => import('source/pages/root/HRPortalPageGroup.vue'),
    meta: {
        title: 'HR Portal - HQZen',
        canDisplayGlobalModals: true,
    },

    children: guardedChildren
}];
